// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from './base-entity';
import { ApplicationUser } from './application-user';
import { Customer } from './customer';
import { TransactionType } from './transaction-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class SalesTransaction extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  salesTransactionId: number;
  amount: number;
  applicationUserId: string;
  createdOn: Date;
  customerId: number;
  description: string;
  exchangeRate: number;
  modifiedOn: Date;
  transactionTypeId: number;
  valueDate: Date;
  applicationUser: ApplicationUser;
  customer: Customer;
  transactionType: TransactionType;
}

